namespace RioERP.Masters {
    export interface EmailTemplatesForm {
        Status: Serenity.EnumEditor;
        Variable: Serenity.LookupEditor;
        EmailTemplate: Serenity.HtmlContentEditor;
        IsActive: Serenity.BooleanEditor;
    }

    export class EmailTemplatesForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.EmailTemplates';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!EmailTemplatesForm.init)  {
                EmailTemplatesForm.init = true;

                var s = Serenity;
                var w0 = s.EnumEditor;
                var w1 = s.LookupEditor;
                var w2 = s.HtmlContentEditor;
                var w3 = s.BooleanEditor;

                Q.initFormType(EmailTemplatesForm, [
                    'Status', w0,
                    'Variable', w1,
                    'EmailTemplate', w2,
                    'IsActive', w3
                ]);
            }
        }
    }
}
